import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import App from 'next/app';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import 'react-multi-carousel/lib/styles.css';
import 'draft-js/dist/Draft.css';

// import 'react-phone-input-2/lib/material.css';

import { DefaultSeo, app } from 'next-seo';
import NProgress from 'nprogress';
import { Router } from 'next/router';
import { initializeApollo, useApollo } from 'config/apollo/apollo-client';
import { getDataFromTree } from '@apollo/react-ssr';
import GlobalStyle, { theme as styledTheme } from '../config/globalStyles';
import materialTheme from '../config/theme';
import { appWithTranslation } from '../config/i18n';
import '../public/modals.css';
import MutationsStatus from '@app/components/molecules/MutationsStatus';
import SnackbarProvider from '@app/providers/SnackbarProvider';
import SpacesProvider from '@app/contexts/SpacesContext';
import SnackNotifications from '@app/components/molecules/SnackNotificationsStatus';
import AuthUserProvider from '@app/contexts/AuthUserContext';
Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: "mubazar@".concat(process.env.npm_package_version),
  enabled: process.env.NEXT_PUBLIC_NODE_ENV === 'production',
  environment: process.env.NEXT_PUBLIC_APP_ENV,
  // autoSessionTracking: true,
  integrations: [
  // Sentry.replayIntegration(),
  new Integrations.BrowserTracing()],
  // Session Replay
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1.0,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
  // autoSessionTracking: true
});
var DEFAULT_SEO = {
  title: 'Mubazar',
  description: 'Find music opportunities near you, Opportunities for musicians. All in one place.',
  openGraph: {
    type: 'website',
    locale: 'en_GB',
    url: 'https://www.mubazar.com',
    title: 'Mubazar',
    description: 'Find music opportunities near you, Opportunities for musicians. All in one place.',
    images: [{
      url: 'https://www.mubazar.com/images/mubazar-logo-BETA-RED.png',
      width: '400',
      height: 400
    }],
    site_name: 'Mubazar'
    // imageWidth: 1200,
    // imageHeight: 1200,
  },
  twitter: {
    // handle: '@garmeeh',
    cardType: 'summary_large_image'
  }
};
function MyApp(_ref) {
  var Component = _ref.Component,
    pageProps = _ref.pageProps,
    err = _ref.err;
  var apolloClient = useApollo(pageProps);
  useEffect(function () {
    var handleRouteChange = function handleRouteChange(url) {
      NProgress.start();
    };
    var handleRouteEnd = function handleRouteEnd(url) {
      NProgress.done();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    };
    Router.events.on('routeChangeStart', handleRouteChange);
    Router.events.on('routeChangeComplete', handleRouteEnd);
    Router.events.on('routeChangeError', handleRouteEnd);
    return function () {
      Router.events.off('routeChangeStart', function () {
        return 1;
      });
      Router.events.off('routeChangeComplete', function () {
        return 1;
      });
      Router.events.off('routeChangeError', function () {
        return 1;
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(ApolloProvider, {
    client: apolloClient
  }, /*#__PURE__*/React.createElement(StyledThemeProvider, {
    theme: styledTheme
  }, /*#__PURE__*/React.createElement(GlobalStyle), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: materialTheme
  }, /*#__PURE__*/React.createElement(AuthUserProvider, null, /*#__PURE__*/React.createElement(SnackbarProvider, null, /*#__PURE__*/React.createElement(SpacesProvider, null, /*#__PURE__*/React.createElement(CssBaseline), /*#__PURE__*/React.createElement(MutationsStatus), /*#__PURE__*/React.createElement(DefaultSeo, DEFAULT_SEO), /*#__PURE__*/React.createElement(Component, _objectSpread(_objectSpread({}, pageProps), {}, {
    err: err
  }))))))));
}
export default appWithTranslation(MyApp);